import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Accordion, Alert, Skeleton } from "@flat-ui";
import { ProjectMemberList } from "@pages/projects/project-member-list";
import { projectMembersSelector, selectedProjectIdSelector } from "@store/projects/projects-selector";
import { fetchProjectDetails } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { sortMembersByNameOrEmail } from "@utils/member-utils";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect, useState } from "react";
/** Renders the members of a project in the share dialog */
export function ProjectMembersAccordion(t0) {
  const $ = _c(21);
  const {
    project,
    location
  } = t0;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const projectMembers = useAppSelector(projectMembersSelector);
  const selectedProjectId = useAppSelector(selectedProjectIdSelector);
  const areMembersAlreadyLoaded = selectedProjectId === project.id;
  const [fetchStatus, setFetchStatus] = useState(areMembersAlreadyLoaded ? "succeeded" : "pending");
  let t1;
  if ($[0] !== projectMembers) {
    t1 = sortMembersByNameOrEmail([...projectMembers]);
    $[0] = projectMembers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortedMembers = t1;
  let t2;
  let t3;
  if ($[2] !== areMembersAlreadyLoaded || $[3] !== companyId || $[4] !== dispatch || $[5] !== handleErrorWithToast || $[6] !== project.id) {
    t2 = () => {
      if (areMembersAlreadyLoaded) {
        return;
      }
      const fetchMembers = async function fetchMembers() {
        setFetchStatus("pending");
        ;
        try {
          await dispatch(fetchProjectDetails({
            companyId,
            projectId: project.id
          })).unwrap();
          setFetchStatus("succeeded");
        } catch (t4) {
          const error = t4;
          setFetchStatus("rejected");
          handleErrorWithToast({
            id: `ProjectMembers-fetchMembers-${Date.now().toString()}`,
            title: "Could not fetch project members",
            error
          });
        }
      };
      fetchMembers();
    };
    t3 = [areMembersAlreadyLoaded, dispatch, companyId, project.id, handleErrorWithToast];
    $[2] = areMembersAlreadyLoaded;
    $[3] = companyId;
    $[4] = dispatch;
    $[5] = handleErrorWithToast;
    $[6] = project.id;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  if (fetchStatus === "pending") {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Skeleton variant="rectangular" height="48px" sx={{
        marginTop: SPACE_ELEMENTS_OF_MODAL
      }} />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (fetchStatus === "rejected") {
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Alert variant="warning" title="Project members could not be fetched" sx={{
        marginTop: SPACE_ELEMENTS_OF_MODAL
      }} />;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  const t4 = `${sortedMembers.length} people are invited`;
  let t5;
  if ($[11] !== trackEvent) {
    t5 = isExpanded => {
      trackEvent({
        name: ProjectEvents.toggleProjectMembers,
        props: {
          isExpanded
        }
      });
    };
    $[11] = trackEvent;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== location || $[14] !== project || $[15] !== sortedMembers) {
    t6 = <ProjectMemberList project={project} members={sortedMembers} location={location} />;
    $[13] = location;
    $[14] = project;
    $[15] = sortedMembers;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <Accordion title={t4} onChange={t5}>{t6}</Accordion>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}